// =========================================================
// * Vue Material Dashboard PRO - v1.3.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-pro
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPlugin from './material-dashboard'

import TokenService from './services/storage.service'
import ApiService from './services/_api.service'

import store from './store'

// Plugins
import App from './App.vue'
import Notifications from './components/NotificationPlugin'
import Chartist from 'chartist'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import Treemap from 'highcharts/modules/treemap'
import draggablePoints from 'highcharts/modules/draggable-points'
import stockInit from 'highcharts/modules/stock'
import mapInit from 'highcharts/modules/map'
import './assets/css/index.css'
//import vennInit from 'highcharts/modules/venn'
import dependencyWheelInit from 'highcharts/modules/dependency-wheel'
import sankeyInit from 'highcharts/modules/sankey'
import More from 'highcharts/highcharts-more'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueSimpleSuggest from 'vue-simple-suggest/lib'
import VueMask from 'v-mask'

Vue.use(VueMask)

// router setup
import router from './router'

import vuetify from './plugins/vuetify'

// plugin setup
Vue.use(VueRouter)
Vue.use(DashboardPlugin)
Vue.use(Notifications)
Vue.use('vue-simple-suggest', VueSimpleSuggest)

Vue.use(VueLodash, { name: 'custom', lodash: lodash })

stockInit(Highcharts)
mapInit(Highcharts)
//vennInit(Highcharts)
sankeyInit(Highcharts)
dependencyWheelInit(Highcharts)
More(Highcharts)
exportingInit(Highcharts)
Treemap(Highcharts)
draggablePoints(Highcharts)

Vue.use(HighchartsVue)

// Set the base URL of the API

// If token exists set header
if (TokenService.getToken()) {
    ApiService.setHeader()
    ApiService.mount401Interceptor()
}

// global library setup
Vue.prototype.$Chartist = Chartist

// translate datepicker
Vue.material.locale.dateFormat = 'dd/MM/yyyy'
Vue.material.locale.days = ['Domingo', 'Segundo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']
Vue.material.locale.shortDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']
Vue.material.locale.shorterDays = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S']
Vue.material.locale.months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
Vue.material.locale.shortMonths = ['Jan', 'Fev', 'Mar', 'Abr', 'Maio', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
Vue.material.locale.shorterMonths = ['J', 'F', 'M', 'A', 'M', 'Ju', 'Ju', 'A', 'Se', 'O', 'N', 'D']

const getApiConfig = async () => {
    const apiConfig = await fetch('/data/api-config.json')
    return await apiConfig.json()
}
getApiConfig().then(function (json) {
    Vue.mixin({
        data() {
            return {
                // Distribute runtime configs into every Vue component
                API_ENDPOINT: json.API
            }
        }
    })

    ApiService.init(json.API)

    /* eslint-disable no-new */
    new Vue({
        vuetify, el: '#app', render: h => h(App), router, store
    })
})
